import React from 'react';
import { useLanguage, useTranslation } from '../contexts/LanguageContext';
import '../styles/components/LanguageSelector.css';

const LanguageSelector = () => {
  const { language, switchLanguage } = useLanguage();
  const { t } = useTranslation();

  const toggle = () => switchLanguage(language === 'en' ? 'fr' : 'en');

  return (
    <button
      className="lang-toggle"
      onClick={toggle}
      aria-label={t('language')}
      title={language === 'en' ? 'Passer en Français' : 'Switch to English'}
    >
      {language === 'en' ? 'EN' : 'FR'}
    </button>
  );
};

export default LanguageSelector;
